import React, { Component } from "react";
import { connect } from "react-redux";
import { updatePressureRoller } from "../actions/";

class PressureRoller extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pressureRoller: [
        {
          value: "Without pressure roller",
          orderCode: "00",
          weight: 0
        },
        {
          value: "With pressure roller",
          orderCode: "10",
          weight: 0
        }
      ]
    };
    this.handleOnchange = this.handleOnchange.bind(this);
  }

  handleOnchange = selected => {
    this.props.onPressureRollerSelect(JSON.parse(selected.target.value));
  };

  componentDidUpdate(prevProps) {
    if (prevProps.winchType.orderCode !== this.props.winchType.orderCode) {
      this.props.onPressureRollerSelect({
        value: "Without pressure roller",
        orderCode: "00",
        weight: 0
      });
      var ele = document.getElementsByName("pressure_roller");
      for (var i = 0; i < ele.length; i++) ele[i].checked = false;
      ele[0].checked = true;
    }
    if (
      prevProps.winchType !== this.props.winchType ||
      prevProps.mType !== this.props.mType ||
      prevProps.previewStatus !== this.props.previewStatus
    ) {
      if (
        this.props.mType === "metric" &&
        this.props.winchType.orderCode === "01"
      ) {
        this.setState({
          pressureRoller: [
            {
              value: "Without pressure roller",
              orderCode: "00",
              weight: 0
            },
            {
              value: "With pressure roller",
              orderCode: "10",
              weight: 2.2
            }
          ]
        });
      } else if (
        this.props.mType === "imperial" &&
        this.props.winchType.orderCode === "01"
      ) {
        this.setState({
          pressureRoller: [
            {
              value: "Without pressure roller",
              orderCode: "00",
              weight: 0
            },
            {
              value: "With pressure roller",
              orderCode: "10",
              weight: 4.9
            }
          ]
        });
      } else if (
        this.props.mType === "metric" &&
        this.props.winchType.orderCode === "02"
      ) {
        this.setState({
          pressureRoller: [
            {
              value: "Without pressure roller",
              orderCode: "00",
              weight: 0
            },
            {
              value: "With pressure roller",
              orderCode: "10",
              weight: 3.4
            }
          ]
        });
      } else if (
        this.props.mType === "imperial" &&
        this.props.winchType.orderCode === "02"
      ) {
        this.setState({
          pressureRoller: [
            {
              value: "Without pressure roller",
              orderCode: "00",
              weight: 0
            },
            {
              value: "With pressure roller",
              orderCode: "10",
              weight: 7.5
            }
          ]
        });
      } else if (
        this.props.mType === "metric" &&
        this.props.winchType.orderCode === "04"
      ) {
        this.setState({
          pressureRoller: [
            {
              value: "Without pressure roller",
              orderCode: "00",
              weight: 0
            },
            {
              value: "With pressure roller",
              orderCode: "10",
              weight: 5.2
            }
          ]
        });
      } else if (
        this.props.mType === "imperial" &&
        this.props.winchType.orderCode === "04"
      ) {
        this.setState({
          pressureRoller: [
            {
              value: "Without pressure roller",
              orderCode: "00",
              weight: 0
            },
            {
              value: "With pressure roller",
              orderCode: "10",
              weight: 11.5
            }
          ]
        });
      } else if (
        this.props.mType === "metric" &&
        this.props.winchType.orderCode === "05"
      ) {
        this.setState({
          pressureRoller: [
            {
              value: "Without pressure roller",
              orderCode: "00",
              weight: 0
            },
            {
              value: "With pressure roller",
              orderCode: "10",
              weight: 4
            }
          ]
        });
      } else if (
        this.props.mType === "imperial" &&
        this.props.winchType.orderCode === "05"
      ) {
        this.setState({
          pressureRoller: [
            {
              value: "Without pressure roller",
              orderCode: "00",
              weight: 0
            },
            {
              value: "With pressure roller",
              orderCode: "10",
              weight: 8.8
            }
          ]
        });
      }
    }
  }

  componentDidMount() {
    if (this.props.previewStatus !== "show") {
      this.props.onPressureRollerSelect({
        value: "Without pressure roller",
        orderCode: "00",
        weight: 0
      });
    }
  }

  render() {
    var pressureRoller = this.state.pressureRoller.map((pRoller, index) => {
      return (
        <div className="col-md-6" key={index}>
          <label>
            <input
              type="radio"
              value={JSON.stringify(pRoller)}
              name="pressure_roller"
              defaultChecked={
                this.props.pressureRoller.orderCode
                  ? this.props.pressureRoller.orderCode === pRoller.orderCode
                  : index === 0
              }
            />{" "}
            {pRoller.value}
          </label>
        </div>
      );
    });
    return (
      <div>
        <div className="field-top">Pressure roller</div>
        <div className="selection-body">
          <p>
            The pressure roller supports a proper spooling of the rope on the
            winch drum.
          </p>
          <div className="row" onChange={this.handleOnchange}>
            {pressureRoller}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    mType: state.mType,
    winchType: state.winchType,
    previewStatus: state.previewStatus,
    pressureRoller: state.pressureRoller
  };
};

const mapActionsToProps = {
  onPressureRollerSelect: updatePressureRoller
};

export default connect(
  mapStateToProps,
  mapActionsToProps
)(PressureRoller);



// WEBPACK FOOTER //
// ./src/components/pressureRoller.js